import 'styles/login/index.scss'

import { ecrannoirDomReady } from '../utils/dom'

ecrannoirDomReady(() => {
  // const btnEye = document.getElementsByClassName
  const toggleBtnPwd = document.getElementById('toggle-btn-pwd');
  const inputPwd = document.getElementById('password_protected_pass');
  if (toggleBtnPwd && inputPwd) {
    console.log('ok');
    
    toggleBtnPwd.addEventListener('click', (e) => {
      e.preventDefault();
      inputPwd.type = inputPwd.type == "password" ? "text" : "password";
    });
  }
  
})
